export function isRecaptchaForm(el: HTMLFormElement): boolean {
  return netbiz.configuration.recaptchaSiteKey && el.hasAttribute('data-recaptcha');
}

export async function getRecaptchaToken(action: string): Promise<string> {
  return new Promise((resolve) => {
    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(netbiz.configuration.recaptchaSiteKey, {
        action: action,
      });
      resolve(token);
    });
  });
}

export function recaptchaFormHandler() {
  if (!netbiz.configuration.recaptchaSiteKey) {
    return;
  }
  const matches = [
    ['login', 'form[data-recaptcha][data-login]'],
    ['register', 'form[data-recaptcha][data-register]'],
  ];

  document.addEventListener('submit', async (e) => {
    let matched = false;
    let formAction: string | undefined = undefined;

    const target = e.target as HTMLFormElement;
    for (const [action, selector] of matches) {
      if (!target.matches(selector)) continue;
      matched = true;
      formAction = action;
    }
    if (!matched) return;
    e.preventDefault();

    const input = target.querySelector<HTMLInputElement>('input[name="grecaptcha"]');

    if (formAction) {
      const token = await getRecaptchaToken(formAction);
      if (input != null) input.value = token;
      target.submit();
    }
  });
}

